module.exports = __webpack_public_path__ + "fonts/68524cb3ee906bd933be3b66e1ec680b.woff";